"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "event-chart"
  }, [_vm._m(0), _c("el-table", {
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "350"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Month",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.monthname) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Full Name",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.adminname) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Points",
      width: "90",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.totalpoints) + " ")];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticStyle: {
      margin: "15px",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "flex-direction": "column"
    }
  }, [_c("p", [_vm._v("Monthly Winners Leaderboard")])]);
}];
render._withStripped = true;